// Save Data to Local Storage
export const setItemLocalStorage = (key: string, value: string) => localStorage.setItem(key, value);
// Read Data from Local Storage
export const getItemLocalStorage = (key: string) => localStorage.getItem(key);
// Remove Data from Local Storage
export const removeItemLocalStorage = (key: string) => localStorage.removeItem(key);
// Remove All (Clear Local Storage)
export const clearLocalStorage = () => localStorage.clear();
